const t = "adyen-pe-transaction-totals", a = "adyen-pe-transaction-totals__item";
export {
  t as BASE_CLASS,
  a as ITEM_CLASS
};
